const Helpers = function (selector, context) {
    let instance = Object.create(Helpers.fn);

    if (selector.nodeType || selector === window || selector instanceof HTMLElement) {
        instance[0] = selector;
        instance.length = 1;
    }
    else if (selector instanceof NodeList || selector instanceof HTMLCollection || selector instanceof Array) {
        for (let i = 0; i < selector.length; i++) {
            instance[i] = selector[i];
        }
        instance.length = selector.length;
    }
    else {
        const elements = (context || document).querySelectorAll(selector);
        if (!elements.length) return instance;
        for (let i = 0; i < elements.length; i++) {
            instance[i] = elements[i];
        }
        instance.length = elements.length;
    }
    return instance;
}

Helpers.fn = {
    css: function (...args) {
        if (args.length === 1 && typeof args[0] === "string") {
            let properties = [];
            for (let i = 0; i < this.length; i++) {
                properties.push(getComputedStyle(this[i])[args[0]])
            }
            return properties;
        }
        else if (args.length === 1 && typeof args[0] === "object") {
            for (let i = 0; i < this.length; i++) {
                for (const property in args[0]) {
                    this[i].style[property] = args[0][property];
                }
            }
        }
        else if (args.length === 2) {
            const property = args[0];
            const value = args[1];
            for (let i = 0; i < this.length; i++) {
                this[i].style[property] = value;
            }
        }
        return this;
    },
    parent: function (selector) {
        const parents = [];
        for (let i = 0; i < this.length; i++) {
            if (this[i].parentNode !== null) {
                if (selector) {
                    const result = checkSelector(selector, this[i].parentNode);
                    if (result) parents.push(result);
                }
                else {
                    parents.push(this[i].parentNode);
                }
            }
        }
        return Helpers(parents);
    },
    parents: function (selector) {
        if (selector === undefined) return;
        const parents = [];
        for (let i = 0; i < this.length; i++) {
            let parent = this[i].parentNode;
            while (parent !== null) {
                const result = checkSelector(selector, parent);
                if (result) {
                    parents.push(result);
                    break;
                }
                parent = parent.parentNode;
            }
        }
        return Helpers(parents);
    },
    children: function (selector) {
        const childrens = [];
        for (let i = 0; i < this.length; i++) {
            let children = this[i].children;
            for (let j = 0; j < children.length; j++) {
                if (selector) {
                    const result = checkSelector(selector, children[j]);
                    if (result) childrens.push(result);
                }
                else {
                    childrens.push(children[j]);
                }
            }
        }
        return Helpers(childrens);
    },
    find: function (selector) {
        const found = [];
        for (let i = 0; i < this.length; i++) {
            const elements = this[i].querySelectorAll(selector);
            for (let j = 0; j < elements.length; j++) {
                found.push(elements[j]);
            }
        }
        return Helpers(found);
    },
    siblings: function (selector) {
        const siblings = [];
        for (let i = 0; i < this.length; i++) {
            const allSiblings = this[i].parentNode.children;
            for (let j = 0; j < allSiblings.length; j++) {
                if (allSiblings[j] === this[i]) continue;
                if (selector) {
                    const result = checkSelector(selector, allSiblings[j]);
                    if (result) siblings.push(result);
                }
                else {
                    siblings.push(allSiblings[j]);
                }
            }
        }
        return Helpers(siblings);
    },
    firstSibling: function (firstSibling) {
        const firstSiblings = [];
        for (let i = 0; i < this.length; i++) {
            const allSiblings = this[i].parentNode.children;
            if (firstSibling) {
                const result = checkSelector(firstSibling, allSiblings[0]);
                if (result) firstSiblings.push(result);
            } else {
                firstSiblings.push(allSiblings[0]);
            }
        }
        return Helpers(firstSiblings);

    },
    lastSibling: function (lastSibling) {
        const lastSiblings = [];
        for (let i = 0; i < this.length; i++) {
            const allSiblings = this[i].parentNode.children;
            if (lastSibling) {
                const result = checkSelector(lastSibling, allSiblings[allSiblings.length - 1]);
                if (result) lastSiblings.push(result);
            } else {
                lastSiblings.push(allSiblings[allSiblings.length - 1]);
            }
        }
        return Helpers(lastSiblings);
    },
    prev: function (selector) {
        const prevElement = [];
        for (let i = 0; i < this.length; i++) {
            const allSiblings = this[i].parentNode.children;
            for (let j = 0; j < allSiblings.length; j++) {
                if (allSiblings[j] === this[i]) {
                    if (allSiblings[j - 1]) {
                        if (selector) {
                            const result = checkSelector(selector, allSiblings[j - 1]);
                            if (result) prevElement.push(result);
                        }
                        else {
                            prevElement.push(allSiblings[j - 1]);
                        }
                    }
                    break;
                };
            }
        }
        return Helpers(prevElement);
    },
    next: function (selector) {
        const nextElement = [];
        for (let i = 0; i < this.length; i++) {
            const allSiblings = this[i].parentNode.children;
            for (let j = 0; j < allSiblings.length; j++) {
                if (allSiblings[j] === this[i]) {
                    const nextSibling = allSiblings[j + 1];
                    if (nextSibling) {
                        if (selector) {
                            const result = checkSelector(selector, nextSibling);
                            if (result) nextElement.push(result);
                        }
                        else {
                            nextElement.push(nextSibling);
                        }
                    }
                    break;
                };
            }
        }
        return Helpers(nextElement);
    },
    each: function (callback) {
        for (let i = 0; i < this.length - 1; i++) {
            callback.call(this[i], this[i], i, this);
        }
    }
}

function checkSelector(selector, targetElement) {
    try {
        if (selector.nodeType || selector instanceof HTMLElement) {
            if (targetElement == selector) return targetElement;
        }
        else if (typeof selector === 'string') {
            if (selector.startsWith('.')) {
                if (targetElement.classList.contains(selector.slice(1))) return targetElement;
            } else if (selector.startsWith('#')) {
                if (typeof targetElement.id != 'undefined' && targetElement.id === selector.slice(1)) return targetElement;
            } else {
                if (targetElement.tagName.toLowerCase() == selector.toLowerCase()) return targetElement;
            }
        } else {
            throw new Error('Invalid Argument: Please input valid argument')
        }
    } catch (e) {
        console.error(e)
    }
}


window._s = Helpers;


export default _s;
